module.exports = __webpack_public_path__ + "assets/img/Cricket-vs-Corona-Cricket-is-winning.88c4c7f5.jpg";